import React, { useState } from "react";
import PaymentMasterList from "./PaymentMasterList";
import CastingDirectorBankSetup from "./CastingDirectorBankSetup";

const PaymentMasterPage = () => {
  const [showForm, setShowForm] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const handleAdd = () => { setSelectedUserId(null); setShowForm(true); };
  const handleEdit = (record) => { setSelectedUserId(record.user_id); setShowForm(true); };
  const handleBack = () => { setSelectedUserId(null); setShowForm(false); };

  return showForm ? (
    <CastingDirectorBankSetup userId={selectedUserId} onBack={handleBack} />
  ) : (
    <PaymentMasterList onAdd={handleAdd} onEdit={handleEdit} />
  );
};

export default PaymentMasterPage;